import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form } from 'react-bootstrap';
import { capitalize } from 'lodash';

const ButtonImport = ({
  hasImportButton,
  isPremium,
  itemName,
  searching,
  smSize,
  variant,
  handleImport,
  idImport
}) => {
  if (!hasImportButton) return '';
  const marginClass = smSize ? 'm-0' : '';
  return (
    <Form.Label
      className="d-inline"
      bsPrefix={`btn btn-${variant} ${marginClass}`}
      htmlFor={idImport}
      disabled={!isPremium && searching}
    >
      <FontAwesomeIcon icon="download" />
      {` Import ${capitalize(itemName)}`}
      <Form.Control // hidden
        type="file"
        disabled={!isPremium && searching}
        id={idImport}
        className="d-none"
        onChange={async event => {
          handleImport(event.target.files[0]);
          // eslint-disable-next-line no-param-reassign
          event.target.value = '';
        }}
      />
    </Form.Label>
  );
};

ButtonImport.defaultProps = {
  hasImportButton: false,
  searching: false,
  smSize: false,
  variant: 'light',
  idImport: 'item-import'
};

ButtonImport.propTypes = {
  hasImportButton: PropTypes.bool,
  isPremium: PropTypes.bool.isRequired,
  itemName: PropTypes.string.isRequired,
  searching: PropTypes.bool,
  smSize: PropTypes.bool,
  variant: PropTypes.string,
  handleImport: PropTypes.func.isRequired,
  idImport: PropTypes.string
};

export default ButtonImport;
